import draftToHtml from 'draftjs-to-html';

const addLinksToMessage = (message) => {
  const entityMap = [];
  let matchCounter = 0;
  const blocks = message.blocks.map((block, i) => {
    const newBlock = { ...block, entityRanges: [] };
    const reg = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const matches = [...String(newBlock.text || '').matchAll(reg)];
    matches.forEach((n) => {
      newBlock.entityRanges.push({ offset: n.index, length: n[0].length, key: matchCounter });
      entityMap[matchCounter] = {
        type: 'LINK',
        mutability: 'MUTABLE',
        data: { url: n[0], target: '_blank' },
      };
      matchCounter++;
    });
    return newBlock;
  });
  return {
    ...message,
    blocks,
    entityMap,
  };
};

const formatEmailMessage = (message) => {
  let formattedMessage = message;
  if (message) {
    //const modifiedMessage = addLinksToMessage(message);
    //formattedMessage = draftToHtml(modifiedMessage);
    formattedMessage = String(formattedMessage || '').replace(/target="_self"/gi, 'target="_blank"');
  }
  return formattedMessage;
};

export const formatRawMessage = (message) => {
  return message;
  // const blocks = message.blocks;
  // return blocks.map((block) => (!block.text.trim() && '\n') || block.text).join('\n');
};

export default formatEmailMessage;
